import { MonthZeroBased } from '@deltasierra/shared';
import { DateTime } from 'luxon';

/**
 * Gets a list of all the calendar dates in a given month
 * Includes trailing dates from the previous and next month
 * For example, if the month starts on a Wednesday, will include the last 3 days of the previous month
 *
 * @param year - The year of the month you want the dates for
 * @param month - The month (0 based) that you want the dates for
 * @returns A list of all of the dates of the month.  Includes prev and next days that trail in the week
 */
export function getCalendarDates(year: number, month: MonthZeroBased): Date[] {
    let current = DateTime.fromJSDate(new Date(year, month)).startOf('month').startOf('week').toJSDate();
    const lastDay = DateTime.fromJSDate(new Date(year, month)).endOf('month').endOf('week').toJSDate();
    const days: Date[] = [];
    if (lastDay < current) {
        // This should never happen
        return [current];
    }
    while (lastDay > current) {
        days.push(current);
        current = DateTime.fromJSDate(current).plus({ days: 1 }).toJSDate();
    }
    return days;
}
